import { render, staticRenderFns } from "./TotalTable.vue?vue&type=template&id=51d1719b&scoped=true&"
import script from "./TotalTable.vue?vue&type=script&lang=js&"
export * from "./TotalTable.vue?vue&type=script&lang=js&"
import style0 from "./TotalTable.vue?vue&type=style&index=0&id=51d1719b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d1719b",
  null
  
)

export default component.exports